import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { Button } from "../../../../Components/Button";
import { URLS } from "../../../../Utilities/Maps";
import { ESupportedGames } from "../../../../@types";
import {
  StyledSteamIcon,
  StyledRiotIcon,
} from "MVVM/Views/MatchHistory/styledComponents";
import { SiEpicgames } from "react-icons/si";
import { useHistory } from "react-router-dom";
import { analytics } from "MVVM/Analytics";

type SignupView = "signup" | "claim";

export const DynamicSignupOptions = ({
  game,
  view = "signup",
}: {
  game: ESupportedGames;
  view?: SignupView;
}) => {
  const isClaimView = view === "claim";

  return (
    <>
      {!isClaimView && (
        <Flex justifyContent="center">
          <Text variant="text.paragraphSmall" textAlign="center">
            {gameToText(game)}
          </Text>
        </Flex>
      )}

      {game === ESupportedGames.CS2 && (
        <>
          <SteamSignup isClaimView={isClaimView} />
        </>
      )}
      {game === ESupportedGames.LOL && <RiotSignup isClaimView={isClaimView} />}
      {game === ESupportedGames.FORTNITE && (
        <EpicSignup isClaimView={isClaimView} />
      )}
    </>
  );
};

const gameToText = (game: ESupportedGames) => {
  if (game === ESupportedGames.CS2)
    return "To claim your clips and start creating epic Counter-Strike 2 content right now, signup with your Steam account.";
  if (game === ESupportedGames.LOL)
    return "To claim your clips and start creating epic League Of Legends content right now, signup with your Riot account.";
  if (game === ESupportedGames.FORTNITE)
    return "To claim your clips and start creating epic Fortnite content right now, signup with your Epic account.";
  return "";
};

const SteamSignup = ({ isClaimView }: { isClaimView: boolean }) => {
  const history = useHistory();
  return (
    <SteamButton
      size="small"
      onClick={() => {
        analytics.track("Dynamic Signup", {
          type: "Steam",
        });
        history.push(`${URLS.AUTH_ROUTES.STEAM}?flow=signup`);
      }}
      $isClaimView={isClaimView}
    >
      <Flex justifyContent="center" alignItems="center">
        <StyledSteamIcon />
        <Text>{`${isClaimView ? "Create & Watch" : "Signup"} with Steam`}</Text>
      </Flex>
    </SteamButton>
  );
};

const RiotSignup = ({ isClaimView }: { isClaimView: boolean }) => {
  const history = useHistory();
  return (
    <RiotButton
      size="small"
      onClick={() => {
        analytics.track("Dynamic Signup", {
          type: "Riot",
        });
        history.push(`${URLS.AUTH_ROUTES.RIOT}?flow=signup`);
      }}
      $isClaimView={isClaimView}
    >
      <Flex justifyContent="center" alignItems="center">
        <StyledRiotIcon />
        <Text>{`${isClaimView ? "Create & Watch" : "Signup"} with Riot`}</Text>
      </Flex>
    </RiotButton>
  );
};

const EpicSignup = ({ isClaimView }: { isClaimView: boolean }) => {
  const history = useHistory();
  return (
    <EpicButton
      size="small"
      onClick={() => {
        analytics.track("Dynamic Signup", {
          type: "Epic",
        });
        history.push(`${URLS.AUTH_ROUTES.EPIC}?flow=signup`);
      }}
      $isClaimView={isClaimView}
    >
      <Flex justifyContent="center" alignItems="center">
        <StyledEpicIcon />
        <Text>{`${isClaimView ? "Claim" : "Signup"} with Epic`}</Text>
      </Flex>
    </EpicButton>
  );
};

const LinkButton = styled(Button)<{ $isClaimView: boolean }>`
  border-radius: 8px;
  color: var(--Ice-100, var(--colors-ice-500100, #f7fcfd));
  min-width: 160px;
  margin-top: ${(props) => (props.$isClaimView ? "0px" : "20px")};
`;

const SteamButton = styled(LinkButton)`
  background-color: rgba(18, 120, 161, 0.2);
  transition: background-color 0.1s ease;
  border: 1px solid rgba(18, 120, 161, 1);
  &:hover {
    background-color: rgba(18, 120, 161, 0.9);
  }
`;

const RiotButton = styled(LinkButton)`
  background-color: rgba(241, 43, 21, 0.2);
  transition: background-color 0.1s ease;
  border: 1px solid rgba(241, 43, 21, 1);
  &:hover {
    background-color: rgba(241, 43, 21, 0.9);
  }
`;

const StyledEpicIcon = styled(SiEpicgames)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
`;

const EpicButton = styled(LinkButton)`
  background-color: rgba(31, 31, 31, 0.2);
  transition: background-color 0.1s ease;
  border: 1px solid ${(props) => props.theme.colors.iceAlpha60};
  &:hover {
    background-color: rgba(31, 31, 31, 0.9);
  }
`;
